import React, { useState, useEffect, useCallback, memo } from 'react'
import axios from 'axios'
import AdSense from './index'

const HappySense = ({ slot = 0, id = '', responsive, height, margin, code_ad, cate_id, params, onlyView, children }) => {
    const [adv, setAdv] = useState(null)

    const getAd = useCallback(() => {
        let _url = `${process.env.REACT_APP_API_URL}/front/v2/ads/${code_ad}${cate_id ? `/${cate_id}` : ''}${params ? `?${params}` : ''}`
        return axios.get(_url)
    }, [code_ad, cate_id, params])

    useEffect(() => {
        if (code_ad) {
            getAd().then(res => {
                setAdv(res.data.result || null)
            })
        } else {
            (window.adsbygoogle = window.adsbygoogle || []).push({})
        }
    }, [code_ad, getAd])

    return (
        <>
            {adv &&
                (code_ad && adv?.idx_b_manager === '1' ? (
                    <AdSense
                        key={id}
                        slot={slot}
                        responsive={responsive}
                        height={height}
                        margin={margin}
                        onlyView={onlyView}
                    />
                ) : (
                    children
                ))}
        </>
    )
}

export default memo(HappySense)



// WEBPACK FOOTER //
// ./src/estimate_list/components/adSense/happySense.js